export const FETCH_LOCATION_TYPE_CATEGORY = {
  START: 'START_FETCH_LOCATION_TYPE_CATEGORY',
  COMPLETE: 'COMPLETE_FETCH_LOCATION_TYPE_CATEGORY',
  FAIL: 'FAIL_FETCH_LOCATION_TYPE_CATEGORY',
  CLEANUP: 'CLEANUP_FETCH_LOCATION_TYPE_CATEGORY',
}

export const UPDATE_LOCATION_TYPE_CATEGORY_DETAILS = {
  START: 'START_UPDATE_LOCATION_TYPE_CATEGORY_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_LOCATION_TYPE_CATEGORY_DETAILS',
  FAIL: 'FAIL_UPDATE_LOCATION_TYPE_CATEGORY_DETAILS',
}
